import React, { useState, useEffect, useCallback, useContext } from 'react';
import { AppTourContext } from '../../context/appTourContext';
import { Tooltip } from 'antd';
import { ENTERPRISE_ENV } from '../../utils/helper';

const CustomTooltip = ({
  children,
  title,
  placement,
  purpleColor,
  customized,
  widget,
  sideNav,
}) => {
  const { isTourActive, tourSkipped, setTourSkipped, tooltipVisible, setTooltipVisible } = useContext(AppTourContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if((tourSkipped || tooltipVisible) && !ENTERPRISE_ENV) {
      setVisible(true);
    }
  }, [tooltipVisible]);

  useEffect(() => {
    // The tooltips will remain for 15 seconds, and after 15 seconds, the tooltips will disappear
    if ((visible && !isTourActive) || tourSkipped) {
      const timer = setTimeout(() => {
        setVisible(false);
        setTourSkipped(false);
        !tourSkipped && setTooltipVisible(false);
        document.removeEventListener('mousedown', handleOutsideClick);
      }, 15 * 1000);

      document.addEventListener('mousedown', handleOutsideClick);

      return () => {
        clearTimeout(timer);
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }
  }, [visible, isTourActive, tourSkipped]);

  const handleOutsideClick = useCallback(event => {
    setVisible(false);
    setTourSkipped(false);
    !tourSkipped && setTooltipVisible(false);
    document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const customTooltipStyles = {
    position: 'absolute',
    top: '300px',
    right: '-50px',
    width: '200px',
    textAlign: 'center',
  };
  const tooltipContentStyles = {
    fontFamily: 'lacquer',
    textTransform: 'lowercase',
  };

  return customized ? (
    visible && !isTourActive && (
      <div style={customTooltipStyles}>
        <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,0 C50,0 70, 90 70, 70" stroke="black" stroke-width="2" fill="transparent" />
        </svg>
        <div style={tooltipContentStyles}>{title}</div>
      </div>
    )
  ) : widget ? (
    <Tooltip
      visible={sideNav ? tourSkipped : visible && !isTourActive}
      title={title}
      overlayClassName={'custom-yellow-tooltip widget-tooltip'}
    >
      <div className="dummy-widget"></div>
    </Tooltip>
  ) : (
    <Tooltip
      title={title}
      visible={sideNav ? tourSkipped : visible && !isTourActive}
      placement={placement}
      overlayClassName={
        purpleColor ? `custom-purple-tooltip ${sideNav && 'nav-tooltip'}` : 'custom-yellow-tooltip'
      }
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
